import { memoizedFetchSiteUserPersonalization } from '@atlassian/jira-personalization-service/src/services/site-user/index.tsx';
import type { Trait } from '@atlassian/jira-personalization-service/src/types.tsx';

export const isNewActiveUser = async (cloudId: string, userId: string) => {
	const userTraits = await memoizedFetchSiteUserPersonalization({ cloudId, userId });
	return findAndCheckActiveDate(userTraits);
};

const findAndCheckActiveDate = (traits: Trait[]): boolean => {
	const traitName = 'jira_first_active';

	const firstActiveTrait = traits.find((trait) => trait.name === traitName);

	if (firstActiveTrait?.value) {
		const oneWeekActive = new Date(firstActiveTrait?.value.toString());
		oneWeekActive.setDate(oneWeekActive.getDate() + 7);
		const today = new Date();
		return today <= oneWeekActive;
	}
	return true;
};
